export const regex = {
  numbersOnly: /^\d+$/,
  password: /^[\x21-\x7E]{8,}$/,
  name: /^[a-zA-Z][a-zA-Z ]*[a-zA-Z]$/,
  phone: /^\+?\d{1,3}?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/,
  urlPattern: /(https?:\/\/[^\s'")]+[^\s.,'")])/g,
  first_name: /^[a-zA-Z ]+$/,
  last_name: /^[a-zA-Z- ]*$/,
};
